import {combineReducers, AnyAction} from 'redux';
import {reducer as formReducer, FormStateMap} from 'redux-form';

import {resources, ResourcesState} from './resources';
import {profile, ProfileState} from './profile';
import {login, LoginState} from './login';
import {runtime, RuntimeState} from './runtime';
import {privilege, PrivilegeState} from './privilege';
import {socialSupport, SocialSupportState} from './socialSupport';
import {news, NewsState} from './news';
import {polls, PollsState} from './polls';
import {snackbar, SnackbarState} from './snackbar';
import {httpWrapper, HttpWrapperState} from './httpWrapper';
import {acceptors, AcceptorsState} from './acceptors';
import {localities, LocalitiesState} from './localities/index';
import {loader, LoaderState} from './loader/index';
import {DobroruState, dobroru} from './dobroru';
import {molodayaArctica, MolodayaArcticaState} from './molodayaArctica';
import {products, ProductsState} from './products';
import {eCertificates, ECertificatesState} from './eCertificates';

const combineReducer = combineReducers<AppStore, AnyAction>({
  form: formReducer,
  resources,
  profile,
  login,
  runtime,
  privilege,
  socialSupport,
  news,
  polls,
  snackbar,
  httpWrapper,
  acceptors,
  localities,
  loader,
  dobroru,
  molodayaArctica,
  products,
  eCertificates,
});

export interface AppStore {
  form: FormStateMap;
  resources: ResourcesState;
  profile: ProfileState;
  login: LoginState;
  runtime: RuntimeState;
  privilege: PrivilegeState;
  socialSupport: SocialSupportState;
  news: NewsState;
  polls: PollsState;
  snackbar: SnackbarState;
  httpWrapper: HttpWrapperState;
  acceptors: AcceptorsState;
  localities: LocalitiesState;
  loader: LoaderState;
  dobroru: DobroruState;
  molodayaArctica: MolodayaArcticaState;
  products: ProductsState;
  eCertificates: ECertificatesState;
}

export default combineReducer;
